/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.fancybox', [
        'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
        'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
    ], function (e) {
        Fancybox.bind("[data-fancybox]", {
            groupAll: true,
            Thumbs: {
                autoStart: false,
            },
        });
    });
    MoyaComponents.register('site.fancy-click', [], function (el) {
        var key = Number(el.dataset.key) + 1;
        util.delegate(el, 'click', '.' + el.className, function (ev) {
            ev.preventDefault();
            var imgElm = document.querySelector('#property__images__big .property__image:nth-of-type(' + key + ') a');
            imgElm.click();
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
